export default __webpack_public_path__ + "static/media/keyword-research.c9c45e8c.svg";